import PolygonLookup from 'polygon-lookup';

import store from '../../../store/configureStore';
import MapProperties from '../../map/Properties';

export default class GovernanceData {
  initialized = false;
  currentView = new MapProperties();
  nearestKeys = [];
  features = new Map();
  lookup = new PolygonLookup();
  currentFeature = {};
  loadComplete = false;
  isLoading = false;
  loadingData = {
    total: 0,
    loaded: new Set()
  };
  constructor(initializer = {}) {
    Object.assign(this, initializer);
  }
  static get ACTIONS() {
    return {
      UPDATE_CURRENT_VIEW: 'UPDATE_CURRENT_VIEW',
      LOAD_FEATURES_BEGIN: 'LOAD_FEATURES_BEGIN',
      ADD_GOVERNANCE_FEATURE: 'ADD_GOVERNANCE_FEATURE',
      ADD_GOVERNANCE_FEATURES: 'ADD_GOVERNANCE_FEATURES'
    };
  }
  initialize() {
    if (store) {
      store.subscribe(GovernanceData.onMoveMap);
    }
  }
  setLoadingFlag() {
    this.isLoading = true;
    this.loadComplete = false;
  }
  unsetLoadingFlag() {
    this.isLoading = false;
    this.loadComplete = true;
  }
  indexFeatures() {
    let featureCollection = (Array.from(this.features)).map(([key, feature]) => {
      return {
        type: feature.type,
        properties: feature.properties,
        geometry: {
          type: feature.geometry.type,
          coordinates: [(feature.geometry.coordinates[0]).map((latLng) => {
            return [
              parseFloat(latLng[0]),
              parseFloat(latLng[1])];
          })]
        }
      };
    });
    this.lookup = new PolygonLookup({
      type: 'FeatureCollection',
      features: featureCollection
    });
  }
  lookupMapCenter({ lat, lng }) {
    if ((this.lookup)
      && (this.lookup.polygons)) {
      let lookupSearchResponse = (this.lookup.search(
        parseFloat(lng),
        parseFloat(lat)));
      return lookupSearchResponse;
    }
  }
  updateCurrentFeature(feature) {
    if (feature !== undefined) {
      this.currentFeature = feature;
    }
    if ((this.currentView) && (this.currentView.view)
      && (this.currentView.view.center) && (this.lookup)
      && (this.lookup.polygons)) {
      this.currentFeature = this.lookup.search(
        parseFloat(this.currentView.view.center.lng),
        parseFloat(this.currentView.view.center.lat));
      this.initialized = true;
    }
  }
  addFeature(key, feature) {
    this.features.set(key, feature);
  }
  updateCurrentView(view, keys, feature) {
    this.currentView = view;
    this.initialized = true;
    this.nearestKeys = [].concat(keys);
    this.updateCurrentFeature(feature);
  }
  static loadFeature(key, total, current) {
  }
  static onMoveMap() {
    let currentView = (store.getState()).map;
    let governanceData = (store.getState()).governanceData;
    if (((governanceData.currentView.view !== currentView.view) ||
      (!governanceData.initialized))
      && ((!governanceData.isLoading))
      && (currentView.view.zoom > 14)
    ) {
      store.dispatch({
        type: GovernanceData.ACTIONS.LOAD_FEATURES_BEGIN
      });
      // let nearestKeys = [];
      // let nearestFeatures = [];
      // let count = 0;
      // let featuresToLoad = 0;
      // let feature;
      // let currentFeature = governanceData.lookupMapCenter(currentView.view.center);
      // if (currentFeature === undefined) {
      //   do {
      //     if (currentView && currentView.view) {
      //       let geoFire = (store.getState()).geoFire;
      //       let geoQuery = geoFire.query({
      //         center: [currentView.view.center.lat, currentView.view.center.lng],
      //         radius: (Math.ceil(((currentView.view.radius + 10) / 1000.0)) * (count + 1))
      //       });
      //       let onKeyEnteredRegistration = geoQuery.on("key_entered", function (key, location, distance) {
      //         nearestKeys.push({
      //           key, location, distance
      //         });
      //       });
      //     }
      //     if (governanceData.features) {
      //       featuresToLoad = (nearestKeys.filter((key) => !(governanceData.features.has(key.key)))).length;
      //       nearestKeys.filter((key) => !(governanceData.features.has(key.key))).map(async (key, index) => {
      //         //Get Boundary JSON file helper folder
      //         var data = require('../../../helpers/BBMP-Wards-New-Formatted-Opencity-ELCITA.json')
      //         //Get the key and value of Boundary JSON and store it in nearestFeatures
      //         for (key in data) {
      //           nearestFeatures.push({
      //             key: key,
      //             feature: data[key]
      //           })
      //         }
      //       });
      //       if (nearestFeatures.length > 0) {
      //         let lookup = new PolygonLookup({
      //           type: 'FeatureCollection',
      //           features: nearestFeatures
      //         });
      //         feature = lookup.search(
      //           parseFloat(currentView.view.center.lng),
      //           parseFloat(currentView.view.center.lat));
      //       }
      //     }
      //     count++;
      //   } while ((count < 20) && (featuresToLoad < 20) && (feature === undefined));
      // }
      // store.dispatch({
      //   type: GovernanceData.ACTIONS.UPDATE_CURRENT_VIEW,
      //   view: currentView,
      //   keys: nearestKeys,
      //   features: nearestFeatures,
      //   feature: feature
      // });
      store.dispatch({
        type: GovernanceData.ACTIONS.UPDATE_CURRENT_VIEW,
        view: currentView,
        keys: [],
        features: [],
        feature: undefined
      });
    }
    else {
    }
  }
  static reducer(state = {}, action) {
    switch (action.type) {
      case GovernanceData.ACTIONS.UPDATE_CURRENT_VIEW: {
        let newState = new GovernanceData(state);
        if (action.features.length > 0) {
          action.features.map((featureItem) => {
            newState.addFeature(featureItem.key, featureItem.feature);
          });
          newState.indexFeatures();
        }
        newState.updateCurrentView(action.view, action.keys, action.feature);
        newState.unsetLoadingFlag();
        return newState;
      }
      case GovernanceData.ACTIONS.LOAD_FEATURES_BEGIN: {
        let newState = new GovernanceData(state);
        newState.setLoadingFlag();
        return newState;
      }
      case GovernanceData.ACTIONS.ADD_GOVERNANCE_FEATURE: {
        let newState = new GovernanceData(state);
        newState.addFeature(action.key, action.feature);
        return newState;
      }
      case GovernanceData.ACTIONS.ADD_GOVERNANCE_FEATURES: {
        let newState = new GovernanceData(state);
        return newState;
      }
      default: {
        return state;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/data/governance/index.js